export interface RegisterSystemTopMenuRequest {
  name: string
  readingInside: string
  readingInsideCollectionList: string
  bibliographyIntegration: string
  bibliographyCollectionBulkEdit: string
  bookbinding: string
  shelfTypeTempChange: string
  collectionList: string
  orderListCreate: string
  orderListSearch: string
  simpleOrdering: string
  acceptCollection: string
  acceptCollectionSimple: string
  acceptCollectionActual: string
  acceptCollectionMagazine: string
  reservationContact: string
  reservationCancel: string
  reservePreferenceAssign: string
  reservationCandidateList: string
  interlibraryLoanLendHistory: string
  interlibraryLoanBorrowingHistory: string
  forwardRequestStatus: string
  forwardRequestAnswer: string
  authorityEdit: string
  operationMenu: string
  passwordChange: string
  defaultValueSetting: string
  inspectionList: string
  inspectionBulkUpdate: string
  batchMenu: string
  jobList: string
  referenceRegister: string
}

export function RegisterSystemTopMenuRequestToJSON(
  value: RegisterSystemTopMenuRequest
): any {
  return {
    name: value.name !== '' ? value.name : undefined,
    reading_inside:
      value.readingInside !== '' ? value.readingInside : undefined,
    reading_inside_collection_list:
      value.readingInsideCollectionList !== ''
        ? value.readingInsideCollectionList
        : undefined,
    bibliography_integration:
      value.bibliographyIntegration !== ''
        ? value.bibliographyIntegration
        : undefined,
    bibliography_collection_bulk_edit:
      value.bibliographyCollectionBulkEdit !== ''
        ? value.bibliographyCollectionBulkEdit
        : undefined,
    bookbinding: value.bookbinding !== '' ? value.bookbinding : undefined,
    shelf_type_temp_change:
      value.shelfTypeTempChange !== '' ? value.shelfTypeTempChange : undefined,
    collection_list:
      value.collectionList !== '' ? value.collectionList : undefined,
    order_list_create:
      value.orderListCreate !== '' ? value.orderListCreate : undefined,
    order_list_search:
      value.orderListSearch !== '' ? value.orderListSearch : undefined,
    simple_ordering:
      value.simpleOrdering !== '' ? value.simpleOrdering : undefined,
    accept_collection:
      value.acceptCollection !== '' ? value.acceptCollection : undefined,
    accept_collection_simple:
      value.acceptCollectionSimple !== ''
        ? value.acceptCollectionSimple
        : undefined,
    accept_collection_actual:
      value.acceptCollectionActual !== ''
        ? value.acceptCollectionActual
        : undefined,
    accept_collection_magazine:
      value.acceptCollectionMagazine !== ''
        ? value.acceptCollectionMagazine
        : undefined,
    reservation_contact:
      value.reservationContact !== '' ? value.reservationContact : undefined,
    reservation_cancel:
      value.reservationCancel !== '' ? value.reservationCancel : undefined,
    reserve_preference_assign:
      value.reservePreferenceAssign !== ''
        ? value.reservePreferenceAssign
        : undefined,
    reservation_candidate_list:
      value.reservationCandidateList !== ''
        ? value.reservationCandidateList
        : undefined,
    interlibrary_loan_lend_history:
      value.interlibraryLoanLendHistory !== ''
        ? value.interlibraryLoanLendHistory
        : undefined,
    interlibrary_loan_borrowing_history:
      value.interlibraryLoanBorrowingHistory !== ''
        ? value.interlibraryLoanBorrowingHistory
        : undefined,
    forward_request_status:
      value.forwardRequestStatus !== ''
        ? value.forwardRequestStatus
        : undefined,
    forward_request_answer:
      value.forwardRequestAnswer !== ''
        ? value.forwardRequestAnswer
        : undefined,
    authority_edit:
      value.authorityEdit !== '' ? value.authorityEdit : undefined,
    operation_menu:
      value.operationMenu !== '' ? value.operationMenu : undefined,
    password_change:
      value.passwordChange !== '' ? value.passwordChange : undefined,
    default_value_setting:
      value.defaultValueSetting !== '' ? value.defaultValueSetting : undefined,
    inspection_list:
      value.inspectionList !== '' ? value.inspectionList : undefined,
    inspection_bulk_update:
      value.inspectionBulkUpdate !== ''
        ? value.inspectionBulkUpdate
        : undefined,
    batch_menu: value.batchMenu !== '' ? value.batchMenu : undefined,
    job_list: value.jobList !== '' ? value.jobList : undefined,
    reference_register:
      value.referenceRegister !== '' ? value.referenceRegister : undefined
  }
}
